import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import { RoutesType } from "types";

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  document.documentElement.dir = "ltr";
  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-stone-50 transition-all duration-500 dark:bg-nature-green-dark">
      <div className="absolute -z-10 h-full w-full bg-gradient-to-br from-stone-50 via-white to-stone-100 dark:from-nature-green-dark dark:via-nature-green-dark/90 dark:to-nature-green-dark"></div>
      <div className="absolute left-0 top-0 -z-10 h-48 w-48 -translate-x-16 -translate-y-16 rounded-full bg-nature-green/10 opacity-70 blur-3xl filter dark:bg-nature-green-dark/20"></div>
      <div className="absolute bottom-0 right-0 -z-10 h-64 w-64 translate-x-20 translate-y-20 rounded-full bg-accent-400/10 opacity-80 blur-3xl filter dark:bg-accent-900/20"></div>
      <main className="relative z-10">{children}</main>
      <div className="fixed bottom-4 right-4 z-20">
        <FixedPlugin />
      </div>
    </div>
  );
};

const getRoutes = (routes: RoutesType[]): any => {
  return routes.map((prop, key) => {
    if (prop.layout === "/auth") {
      return (
        <Route path={`/${prop.path}`} element={prop.component} key={key} />
      );
    } else {
      return null;
    }
  });
};

export default function Auth() {
  return (
    <AuthLayout>
      <div className="mb-auto flex flex-col">
        <Routes>
          {getRoutes(routes)}
          <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
        </Routes>
      </div>
    </AuthLayout>
  );
}
